import DeleteModal from '@Components/Modal/DeleteModal';
import { useDisclosure } from '@hooks/useDisclosure';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { useGreenhouseForm } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider';
import { IOtherDetailFormValues } from '@Router/EsgGreenhouse/Containers/EsgGreenhouseFormProvider/types';
import { useWatch } from 'react-hook-form';

type OtherGreenhouseDeleteButtonProp = { rowId: number | string };

const OtherGreenhouseDeleteButton = ({
  rowId,
}: OtherGreenhouseDeleteButtonProp) => {
  const [opened, { open, close }] = useDisclosure();
  const { setValue, getValues } = useGreenhouseForm();
  const isNewDetails = typeof rowId === 'string';

  const completedSection = useWatch({
    name: 'greenhouseGoalTerm.completedSection',
  });

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  const handleDeleteOtherGreenhouse = () => {
    const otherDetails = getValues(
      'greenhouseGoalTerm.other.details'
    ) as IOtherDetailFormValues[];

    const currentIndex = isNewDetails
      ? Number(rowId.replace('NEW-', '')) - 1
      : otherDetails.findIndex((detail) => detail.id === rowId);

    const updatedDetails = otherDetails.filter(
      (_, index) => index !== currentIndex
    );

    setValue('greenhouseGoalTerm.other.details', updatedDetails);

    close();
  };

  return (
    <>
      <GridActionsCellItem
        key="delete"
        icon={<DeleteOutlineIcon style={{ fontSize: '16px' }} />}
        disabled={isCompletedTh || isCompletedEn}
        label="Delete"
        onClick={open}
      />
      <DeleteModal
        topic="การตั้งเป้าหมายการลดก๊าซเรือนกระจกอื่น ๆ"
        opened={opened}
        close={close}
        confirm={handleDeleteOtherGreenhouse}
      />
    </>
  );
};

export default OtherGreenhouseDeleteButton;
